<div class="side-menu"
     [class.disabled]="!userDetails || !userDetails?.hasConciergeRights"
     [class.side-menu--expanded]="isExpanded" (mouseenter)="expand()" (mouseleave)="collapse()">
     <!-- || !isActiveView -->
  <div class="side-menu__logo">
    <img src="/assets/icons/logo.svg" alt="Logo" />
    <p *ngIf="isExpanded" class="side-menu__logo__title">MERGE</p>
  </div>
  <div>
    <ng-container *ngFor="let menuItem of menuItems">
      <app-side-menu-item
        [value]="menuItem"
        [isSideMenuExpanded]="isExpanded"
        (expanded)="menuItemExpandedHandler(menuItem)"
      ></app-side-menu-item>
    </ng-container>
  </div>

  <app-user-profile-side-menu [isSideMenuToggle]="isExpanded"></app-user-profile-side-menu>
</div>
